import HotelRoom from '../../../types/RoomAvailability';
import request from '../request';

type Params = {
  hotelId: string;
  checkInDate: string;
  checkOutDate: string;
  guestCountString: string;
  roomCount: number;
  locale: string;
};

const getHotelRooms = async (
  { hotelId, checkInDate, checkOutDate, guestCountString, roomCount, locale }: Params,
  signal?: AbortSignal
) => {
  const parameters = {
    check_in_date: checkInDate,
    check_out_date: checkOutDate,
    guest_per_rooms: guestCountString,
    room_count: roomCount,
    locale,
  } as unknown as Record<string, string>;

  const hotelRoomsFromApi = await request<HotelRoom[]>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/hotels/${hotelId}/plans?${new URLSearchParams(
      parameters
    ).toString()}`,
    method: 'GET',
    signal,
  });

  return hotelRoomsFromApi;
};

export default getHotelRooms;
